import api from "../axiosInstance";

// Get all categories
export async function getAllCategories() {
  const resp = await api.get("/api/v1/code-values/categories");
  return resp.data;
}

// Get values by category (for dropdowns)
export async function getValuesByCategory(category, activeOnly = true) {
  const resp = await api.get(
    `/api/v1/code-values/${category}?activeOnly=${activeOnly}`
  );
  return resp.data;
}

// Get specific value by category and code
export async function getValueByCategoryAndCode(category, code) {
  const resp = await api.get(`/api/v1/code-values/${category}/${code}`);
  return resp.data;
}

// Get all values (admin view)
export async function getAllValues(category = null, activeOnly = true) {
  let url = "/api/v1/code-values";
  const params = new URLSearchParams();

  if (category) {
    params.append("category", category);
  }
  if (activeOnly !== null) {
    params.append("activeOnly", activeOnly);
  }

  if (params.toString()) {
    url += `?${params.toString()}`;
  }

  const resp = await api.get(url);

  return resp.data;
}

// Create new code/value entry
export async function createCodeValue(data) {
  console.log(data);

  const resp = await api.post("/api/v1/code-values", data);
  return resp.data;
}

// Update code/value entry
export async function updateCodeValue(id, data) {
  const resp = await api.put(`/api/v1/code-values/${id}`, data);
  return resp.data;
}

// Delete code/value entry (soft delete)
export async function deleteCodeValue(id) {
  const resp = await api.delete(`/api/v1/code-values/${id}`);
  return resp.data;
}

// Helper function to get dropdown options for a category
export async function getDropdownOptions(category, activeOnly = true) {
  try {
    const response = await getValuesByCategory(category, activeOnly);
    return response.data || [];
  } catch (error) {
    console.error(
      `Error fetching dropdown options for category ${category}:`,
      error
    );
    return [];
  }
}

// Helper function to get all categories for filter dropdown
export async function getCategoryOptions() {
  try {
    const response = await getAllCategories();
    return response.data || [];
  } catch (error) {
    console.error("Error fetching categories:", error);
    return [];
  }
}

// Category Management APIs

// Create new category
export async function createCategory(data) {
  const resp = await api.post("/api/v1/code-values/categories", data);
  return resp.data;
}

// Update/rename category
export async function updateCategory(data) {
  const resp = await api.put("/api/v1/code-values/categories", data);
  return resp.data;
}

// Delete category
export async function deleteCategory(data) {
  const resp = await api.delete("/api/v1/code-values/categories", { data });
  return resp.data;
}

// Get category statistics
export async function getCategoryStats(category = null) {
  let url = "/api/v1/code-values/categories/stats";
  if (category) {
    url += `?category=${encodeURIComponent(category)}`;
  }
  const resp = await api.get(url);
  return resp.data;
}
